/** FAQ, Support, and Advertising page copy (Slovenian). */
export const pagesMessagesSl = {
  faq: {
    pageTitle: "Pogosta vprašanja",
    pageSubtitle: "Poiščite odgovore na pogosta vprašanja o WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Odgovori na pogosta vprašanja o WasOK, skeniranju izdelkov, zasebnosti in ocenah.",
    items: [
      {
        question: "Kako deluje WasOK?",
        answer:
          "WasOK vam pomaga zapomniti si, kateri izdelki so vam bili všeč ali ne, tako da skenira črtne kode ter shranjuje vaše ocene in zapiske. Preprosto optično preberite črtno kodo izdelka, ga ocenite, dodajte zapiske, in ko naslednjič skenirate isti izdelek, boste takoj videli svojo prejšnjo oceno.",
      },
      {
        question: "So moji podatki shranjeni v oblaku?",
        answer:
          "Ne! Vsi vaši podatki so shranjeni lokalno na vaši napravi. Vaših informacij ne sinhroniziramo v oblak, kar pomeni, da vaša zgodovina nakupov in mnenja o izdelkih ostanejo popolnoma zasebni. Vendar to tudi pomeni, da bi morali napravo varnostno kopirati, če želite ohraniti svoje podatke.",
      },
      {
        question: "Ali za uporabo WasOK potrebujem internetno povezavo?",
        answer:
          "Ne, WasOK deluje popolnoma brez povezave. Ker so vsi vaši podatki shranjeni lokalno na vaši napravi, lahko skenirate izdelke, dodajate ocene in si ogledujete zgodovino brez kakršne koli internetne povezave.",
      },
      {
        question: "Ali lahko WasOK uporabljam za katero koli vrsto izdelka?",
        answer:
          "Da! WasOK deluje z vsakim izdelkom, ki ima črtno kodo. Ne glede na to, ali gre za hrano, kozmetiko, gospodinjske izdelke, elektroniko ali karkoli drugega s črtno kodo, ga lahko skenirate in shranite svoje mnenje.",
      },
      {
        question: "Kako optično preberem črtno kodo?",
        answer:
          "Preprosto odprite aplikacijo WasOK in tapnite gumb za skeniranje. Usmerite kamero na črtno kodo izdelka in aplikacija jo bo samodejno zaznala in skenirala. Za najboljše rezultate poskrbite, da je črtna koda dobro osvetljena in v fokusu.",
      },
      {
        question: "Ali lahko svojim ocenam izdelkov dodam fotografije?",
        answer:
          "Da! Fotografije lahko priložite kateri koli oceni izdelka. To je še posebej koristno za zapomnitev podrobnosti embalaže, seznama sestavin ali katerih koli drugih vizualnih informacij, ki vam lahko pomagajo, da se spomnite, zakaj vam je bil izdelek všeč ali ne.",
      },
      {
        question: "Katere informacije lahko shranim o izdelkih?",
        answer:
          "Shranite lahko ocene (1-5 zvezdic), besedilne zapiske, fotografije, ceno, ki ste jo plačali, kraj nakupa in lastne kategorije. Te celovite informacije vam pomagajo pri sprejemanju premišljenih odločitev pri nakupovanju.",
      },
      {
        question: "Ali lahko ustvarjam nakupovalne sezname?",
        answer:
          "Da! WasOK vam omogoča ustvarjanje nakupovalnih seznamov iz izdelkov, ki ste jih že ocenili. To olajša zapomnitev, kateri izdelki so vam bili všeč in jih želite ponovno kupiti.",
      },
      {
        question: "Kako organiziram svoje izdelke?",
        answer:
          "Izdelke lahko organizirate z uporabo lastnih kategorij. Ustvarite lahko na primer kategorije, kot so »Prigrizki«, »Kava«, »Nega kože« ali »Čistilna sredstva«. To olajša brskanje po vaših ocenah glede na vrsto.",
      },
      {
        question: "Je WasOK brezplačen za uporabo?",
        answer:
          "Da, WasOK je popolnoma brezplačen za prenos in uporabo. Ni nakupov znotraj aplikacije, naročnin ali skritih stroškov. Verjamemo, da bi moral imeti vsak dostop do zasebnega načina za zapomnitev svojih preferenc glede izdelkov.",
      },
      {
        question: "Je WasOK dostopen?",
        answer:
          "WasOK je zasnovan tako, da ga lahko uporablja čim več ljudi. Aplikacija vključuje funkcije dostopnosti, kot so podpora za bralnik zaslona, prilagodljivo besedilo in izbirni način visokega kontrasta.",
      },
      {
        question: "Kaj se zgodi, če aplikacijo odstranim?",
        answer:
          "Ker so vsi podatki shranjeni lokalno na vaši napravi, bo odstranitev aplikacije izbrisala vse vaše ocene izdelkov, zapiske in nakupovalne sezname. Pred odstranitvijo obvezno izvozite svoje podatke, če želite ohraniti varnostno kopijo.",
      },
      {
        question: "Ali lahko izvozim svoje podatke?",
        answer:
          "Da, WasOK vam omogoča izvoz podatkov za namene varnostnega kopiranja. Vse svoje ocene lahko izvozite v datoteko, ki jo lahko shranite na svojo napravo ali v izbrano oblačno shrambo.",
      },
      {
        question: "Ali WasOK sledi moji lokaciji?",
        answer:
          "Ne, WasOK ne sledi vaši lokaciji. Čeprav lahko ročno vnesete ime trgovine, kjer ste kupili izdelek, aplikacija ne uporablja GPS-a ali storitev lokacije.",
      },
      {
        question: "Ali lahko WasOK uporabljam na več napravah?",
        answer:
          "Trenutno se WasOK ne sinhronizira med napravami, saj so vsi podatki shranjeni lokalno. Vsaka naprava bo imela svojo ločeno bazo podatkov izdelkov in ocen.",
      },
      {
        question: "Kaj, če se črtna koda ne skenira?",
        answer:
          "Če se črtna koda ne skenira, preverite, ali je dobro osvetljena in v fokusu. Prav tako lahko poskusite očistiti lečo kamere. Če je črtna koda poškodovana ali nejasna, boste morda lahko številko črtne kode vnesli ročno.",
      },
    ],
    cta: {
      heading: "Imate še vprašanja?",
      body: "Obrnite se na našo podporno ekipo — z veseljem vam bomo pomagali.",
      button: "Kontaktirajte podporo",
    },
  },
  support: {
    pageTitle: "Podpora",
    seoTitle: "Podpora — WasOK",
    seoDescription:
      "Pridobite pomoč za WasOK: kontaktirajte podporo, prijavite napake in delite povratne informacije.",
    getHelp: {
      title: "Pridobite pomoč",
      body: "Tu smo, da vam pomagamo kar najbolje izkoristiti WasOK. Če imate težave ali vprašanja, imamo na voljo več virov, ki vam bodo v pomoč.",
    },
    faq: {
      title: "Pogosta vprašanja",
      body: "Preden nas kontaktirate, si oglejte naš razdelek s pogostimi vprašanji, kjer odgovarjamo na najpogostejša vprašanja o WasOK. Tam boste našli podrobne informacije o tem, kako aplikacija deluje, o zasebnosti, shranjevanju podatkov in drugem.",
    },
    contact: {
      title: "Kontaktirajte podporo",
      body: "Če ne najdete odgovora, ki ga iščete, vam je naša podporna ekipa pripravljena pomagati. Kontaktirate nas lahko na:",
      emailLabel: "E-pošta:",
      responseTime: "Običajno odgovorimo v 24-48 urah",
    },
    bugs: {
      title: "Prijava napak",
      body: "Ste našli napako? Cenimo vašo pomoč pri izboljševanju WasOK. Pri prijavi napake, prosimo, vključite:",
      items: [
        "Podroben opis težave",
        "Korake za ponovitev težave",
        "Model vaše naprave in različico Androida",
        "Posnetke zaslona ali videoposnetke zaslona, če je mogoče",
      ],
      sendPrefix: "Prijave napak pošljite na:",
    },
    featureRequests: {
      title: "Predlogi za nove funkcije",
      bodyBefore: "Imate idejo za novo funkcijo? Z veseljem jo bomo prisluhnili! Svoje predloge pošljite na",
      bodyAfter:
        ". Čeprav ne moremo uresničiti vsake zahteve, pri načrtovanju prihodnjih posodobitev skrbno upoštevamo vse povratne informacije.",
    },
    knownIssues: {
      title: "Znane težave",
      body: "Trenutno se zavedamo naslednjih težav in delamo na rešitvah:",
      items: [
        "Nekatere črtne kode se morda ne bodo skenirale v slabih svetlobnih pogojih — poskusite uporabiti bliskavico",
        "Zelo dolgi zapiski o izdelku se lahko na starejših napravah shranjujejo malo dlje",
        "Sličice slik se lahko na zaslonih visoke ločljivosti prikažejo pikselizirane",
      ],
    },
    appUpdates: {
      title: "Posodobitve aplikacije",
      body: "Redno izdajamo posodobitve z novimi funkcijami, izboljšavami in popravki napak. Poskrbite, da WasOK posodabljate prek trgovine Google Play, da boste prejeli najnovejše izboljšave.",
    },
    community: {
      title: "Skupnost",
      body: "Pridružite se naši skupnosti uporabnikov, ki z WasOK sprejemajo pametnejše odločitve pri nakupovanju. Delite nasvete, zastavljajte vprašanja in se povežite z drugimi uporabniki na naših družbenih omrežjih.",
    },
    emergency: {
      title: "Nujna podpora",
      body: 'Če imate kritično težavo, ki vam onemogoča uporabo aplikacije, prosimo, v zadevi svojega e-poštnega sporočila označite »URGENT«, mi pa bomo vašo zahtevo obravnavali prednostno.',
    },
    cta: {
      heading: "Še vedno potrebujete pomoč?",
      body: "Naša podporna ekipa je tu za vas. Ne oklevajte in nas kontaktirajte z vsemi vprašanji ali pomisleki.",
      button: "Pošljite e-pošto podpori",
    },
  },
  advertising: {
    pageTitle: "Oglaševanje in monetizacija",
    seoTitle: "Oglaševanje — WasOK",
    seoDescription: "Kako WasOK pristopa k oglaševanju in monetizaciji.",
    approach: {
      title: "Naš pristop",
      body: "Pri WasOK verjamemo, da so vaše nakupovalne navade in mnenja o izdelkih zasebni in osebni. Naš poslovni model odraža to temeljno vrednoto.",
    },
    noAds: {
      title: "Brez oglasov",
      body: "WasOK ne prikazuje nobenih oglasov. Nikoli vam ne bomo prikazovali oglasov na podlagi izdelkov, ki jih skenirate, ocen, ki jih dodelite, ali katerih koli drugih podatkov, ki jih ustvarite v aplikaciji. Vaša izkušnja z WasOK je popolnoma brez oglasov.",
    },
    noDataSelling: {
      title: "Brez prodaje podatkov",
      body: "Vaših podatkov ne prodajamo, ne oddajamo v najem ali delimo z oglaševalci, posredniki podatkov ali katerimi koli tretjimi osebami. Ker so vsi vaši podatki shranjeni lokalno na vaši napravi, do njih nimamo dostopa niti mi. Vaše ocene izdelkov, nakupovalni seznami in zapiski so samo vaši.",
    },
    noTracking: {
      title: "Brez sledenja",
      body: "WasOK ne uporablja slednih slikovnih pik, analitičnih storitev ali katere koli druge tehnologije, ki spremlja vaše vedenje ali deli informacije s tretjimi osebami. Ne sledimo, katere izdelke skenirate, v katerih trgovinah nakupujete ali kako uporabljate aplikacijo.",
    },
    sustainability: {
      title: "Kako ostajamo vzdržni",
      body: "Morda se sprašujete, kako ohranjamo WasOK brezplačen brez oglasov ali prodaje podatkov. Naš pristop je preprost:",
      items: [
        {
          label: "Brezplačno in odprto:",
          text: "WasOK je brezplačen za uporabo vsem, brez premijskih ravni ali plačljivih omejitev",
        },
        {
          label: "Vitko poslovanje:",
          text: "Stroške ohranjamo nizke z gradnjo učinkovite programske opreme, osredotočene na zasebnost",
        },
        {
          label: "Neobvezne donacije:",
          text: "Uporabniki, ki imajo WasOK radi, nas lahko podprejo s prostovoljnimi donacijami",
        },
        {
          label: "Odprta koda:",
          text: "Organizacijam lahko ponudimo svetovalne ali razvojne storitve po meri",
        },
      ],
    },
    noAffiliate: {
      title: "Brez pridruženih povezav",
      body: "WasOK ne uporablja pridruženih povezav in ne prejema provizij od trgovcev. Ko skenirate izdelek, vas ne preusmerimo nikamor za nakup. Aplikacija je namenjena izključno vašemu osebnemu vodenju evidenc in odločanju.",
    },
    noPromotions: {
      title: "Brez promocije izdelkov",
      body: "Ne sprejemamo plačil od znamk ali proizvajalcev za promocijo njihovih izdelkov. WasOK vam nikoli ne bo predlagal izdelkov, izpostavljal določenih znamk ali kakor koli vplival na vaše ocene. Vaša mnenja so samo vaša.",
    },
    partnerships: {
      title: "Partnerstva s tretjimi osebami",
      body: "WasOK ne sodeluje z marketinškimi podjetji, agregatorji podatkov ali oglaševalskimi omrežji. Delujemo neodvisno in nad vse postavljamo vašo zasebnost.",
    },
    future: {
      title: "Načrti za prihodnost",
      body: "Zavezani smo k temu, da WasOK ostane brez oglasov in osredotočen na zasebnost. Če bi kdaj v prihodnosti morali uvesti vzdržen poslovni model, bomo:",
      items: [
        "Vse spremembe najavili dovolj vnaprej",
        "Nikoli ne bomo ogrozili zasebnosti ali varnosti podatkov",
        "Vedno ponudili način uporabe aplikacije brez sledenja ali oglasov",
        "Prisluhnili povratnim informacijam in pomislekom uporabnikov",
      ],
    },
    supporting: {
      title: "Podpora WasOK",
      body: "Če imate WasOK radi in želite podpreti naše poslanstvo zasebnega nakupovalnega spomina, lahko:",
      items: [
        "Poveste prijateljem in družini o aplikaciji",
        "Pustite pozitivno oceno v trgovini Google Play",
        "Delite z nami svoje povratne informacije in predloge",
        "Razmislite o prostovoljni donaciji (ko je na voljo)",
      ],
    },
    cta: {
      heading: "Vprašanja o naših pravilnikih?",
      body: "Smo pregledni glede tega, kako WasOK deluje. Če imate kakršna koli vprašanja o našem pristopu k zasebnosti, monetizaciji ali vzdržnosti, nas prosimo kontaktirajte.",
      button: "Kontaktirajte nas",
    },
  },
};
